/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class ImpactsApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Get the list of impacts
     * @param page 
     * @param status 
     */
    public getImpacts(page?: number, status?: string, __unused?: any): Observable<PagedArray<models.ApiImpact>> {
        const path = '/content/impacts';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 
        if (page !== undefined) {
            queryParameters['page'] = <any>page;
        }

        if (status !== undefined) {
            queryParameters['status'] = <any>status;
        }


        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<PagedArray<models.ApiImpact>>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
